import type { Dialog } from "@/types/dialog";
import { useDialogStore } from "./dialog-store";
import { DialogLineItem } from "./DialogLineItem";

interface DialogLineListProps {
  dialog: Dialog;
  scrollToLine: number | null;
}

export function DialogLineList({ dialog, scrollToLine }: DialogLineListProps) {
  const activeLine = useDialogStore((s) => s.activeLine);

  return (
    <div className="mb-8">
      {dialog.lines.map((line) => (
        <DialogLineItem
          key={line.index}
          line={line}
          speaker={dialog.speakers[line.speakerIndex]}
          speakerThumbnailUrl={dialog.speaker_thumbnails?.[String(line.speakerIndex)]?.url ?? null}
          dialogId={dialog.id}
          languageCode={dialog.language_code}
          isActive={activeLine === line.index}
          shouldScrollTo={scrollToLine === line.index}
        />
      ))}
    </div>
  );
}
